import React from 'react'

const BarangayContact = ({ barangay }) => {
  // Check if social media links are valid URLs
  const isValidUrl = (url) => {
    return url && (url.startsWith('http://') || url.startsWith('https://'))
  }

  const hasFacebook = isValidUrl(barangay.facebook)
  const hasTwitter = isValidUrl(barangay.twitter)

  const hasContactInfo = barangay.contact_number || barangay.email ||
                        barangay.address || barangay.address2 ||
                        hasFacebook || hasTwitter

  if (!hasContactInfo) return null

  return (
    <section className="section bg-theme-alt tc-light">
      <div className="container">
        <div className="section-head text-center mb-5">
          <h2 className="title title-s4">Contact Information</h2>
          <p>Get in touch with {barangay.name}</p>
        </div>
        <div className="row justify-content-center gutter-vr-40px">
          <div className="col-lg-8">
            <div className="row">
              {/* Address */}
              {(barangay.address || barangay.address2) && (
                <div className="col-md-6 mb-4">
                  <div className="contact-item text-center">
                    <div className="contact-icon mb-3">
                      <em className="fas fa-map-marker-alt" style={{ fontSize: '2.5rem', color: '#ffd700' }}></em>
                    </div>
                    <h5 className="mb-2">Address</h5>
                    {barangay.address && <p className="mb-0">{barangay.address}</p>}
                  </div>
                </div>
              )}

              {/* Contact Number */}
              {barangay.contact_number && (
                <div className="col-md-6 mb-4">
                  <div className="contact-item text-center">
                    <div className="contact-icon mb-3">
                      <em className="fas fa-phone" style={{ fontSize: '2.5rem', color: '#ffd700' }}></em>
                    </div>
                    <h5 className="mb-2">Phone</h5>
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0, textAlign: 'left', display: 'inline-block' }}>
                      {barangay.contact_number.split('\n').filter(line => line.trim()).map((line, index) => (
                        <li key={index} style={{ marginBottom: '8px', fontSize: '0.9rem' }}>
                          <span style={{ color: '#ffd700', marginRight: '5px' }}>√</span>
                          <span style={{ color: '#ffffff' }}>
                            {line.replace('√', '').trim()}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}

              {/* Email */}
              {barangay.email && (
                <div className="col-md-6 mb-4">
                  <div className="contact-item text-center">
                    <div className="contact-icon mb-3">
                      <em className="fas fa-envelope" style={{ fontSize: '2.5rem', color: '#ffd700' }}></em>
                    </div>
                    <h5 className="mb-2">Email</h5>
                    <p className="mb-0">
                      <a href={`mailto:${barangay.email}`} style={{ color: '#ffffff' }}>
                        {barangay.email}
                      </a>
                    </p>
                  </div>
                </div>
              )}

              {/* Facebook */}
              {hasFacebook && (
                <div className="col-md-6 mb-4">
                  <div className="contact-item text-center">
                    <div className="contact-icon mb-3">
                      <em className="fab fa-facebook" style={{ fontSize: '2.5rem', color: '#ffd700' }}></em>
                    </div>
                    <h5 className="mb-2">Facebook</h5>
                    <p className="mb-0">
                      <a href={barangay.facebook} target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', wordBreak: 'break-all' }}>
                        {barangay.facebook}
                      </a>
                    </p>
                  </div>
                </div>
              )}

              {/* Twitter */}
              {hasTwitter && (
                <div className="col-md-6 mb-4">
                  <div className="contact-item text-center">
                    <div className="contact-icon mb-3">
                      <em className="fab fa-twitter" style={{ fontSize: '2.5rem', color: '#ffd700' }}></em>
                    </div>
                    <h5 className="mb-2">Twitter</h5>
                    <p className="mb-0">
                      <a href={barangay.twitter} target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff', wordBreak: 'break-all' }}>
                        {barangay.twitter}
                      </a>
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BarangayContact
